import React, { useState } from 'react'
import Avatar from "../../assets/Images/user-avatar.jpg"
import { FaThumbsUp } from "react-icons/fa6"
import { AiFillDislike } from "react-icons/ai"
import { BsChatFill } from "react-icons/bs"
import { FaShare, FaEye } from "react-icons/fa6"
import { FiMonitor } from "react-icons/fi"
import { HiDeviceMobile } from "react-icons/hi"
import { MdOutlinePreview } from "react-icons/md"

const LivePreview = ({
  icon, annTypeData, subject, anntypeDes, selectedTagEmp,
  banner, reactionAllowId, reactionDislikeId, commentId,
  repliesId, approveComments, width = "100%", height = "auto"
}) => {
  const [deviceView, setDeviceView] = useState('desktop')

  const hasContent = subject || anntypeDes || banner

  return (
    <div style={{ width, height }}>
      {/* ── Panel header ── */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px'
      }}>
        <div style={{
          width: 30, height: 30, borderRadius: '8px',
          background: 'linear-gradient(135deg,#8660F8,#c4b5fd)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <MdOutlinePreview style={{ color: '#fff', fontSize: 15 }} />
        </div>
        <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
          Live Preview
        </h3>
        {hasContent && (
          <span style={{
            marginLeft: 'auto', fontSize: '10px', padding: '2px 8px',
            borderRadius: '20px', background: '#22C55E20',
            border: '1px solid #22C55E40', color: '#22C55E', fontWeight: 600
          }}>LIVE</span>
        )}
      </div>

      {/* ── Preview card ── */}
      <div style={{
        background: 'linear-gradient(135deg,#F9731610 0%,#EA580C08 100%)',
        border: '1px solid #F9731630',
        borderRadius: '14px', overflow: 'hidden',
        transition: 'all 0.3s ease',
        maxWidth: deviceView === 'mobile' ? '280px' : '100%',
        margin: deviceView === 'mobile' ? '0 auto' : '0',
      }}>
        {/* Card header */}
        <div style={{
          padding: '12px 14px',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg,#F97316,#EC4899)',
              padding: '2px'
            }}>
              <img src={Avatar} alt="" style={{
                width: '100%', height: '100%', borderRadius: '50%',
                objectFit: 'cover', border: '2px solid rgba(22,22,44,0.9)'
              }} />
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                  Sharah Johnson
                </span>
                {icon && <img src={icon} style={{ width: 16, height: 16, borderRadius: '4px' }} />}
              </div>
              <span style={{ fontSize: '11px', color: 'var(--secondary-text-color)' }}>2 minutes ago</span>
            </div>
          </div>
          <span style={{
            display: 'flex', alignItems: 'center', gap: '4px',
            fontSize: '11px', color: 'var(--secondary-text-color)'
          }}>
            <FaEye style={{ fontSize: 12 }} /> 24
          </span>
        </div>

        {/* Content area */}
        <div style={{ padding: '14px' }}>
          {subject ? (
            <h4 style={{
              margin: '0 0 8px', fontSize: '14px', fontWeight: 600,
              color: 'var(--primary-text-color)'
            }}>{subject}</h4>
          ) : (
            <div style={{
              height: '14px', borderRadius: '4px', marginBottom: '8px',
              background: 'rgba(255,255,255,0.06)', width: '70%'
            }} />
          )}

          {anntypeDes ? (
            <div style={{ fontSize: '12px', color: 'var(--secondary-text-color)', lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: anntypeDes }} />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {[100, 85, 60].map((w, i) => (
                <div key={i} style={{
                  height: '10px', borderRadius: '4px',
                  background: 'rgba(255,255,255,0.05)', width: `${w}%`
                }} />
              ))}
            </div>
          )}

          {banner && (
            <img src={banner} alt="banner" style={{
              width: '100%', borderRadius: '10px', marginTop: '12px',
              objectFit: 'cover', maxHeight: '160px'
            }} />
          )}

          {/* Tagged people */}
          {selectedTagEmp?.length > 0 && (
            <div style={{
              marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '6px'
            }}>
              {selectedTagEmp.map((emp) => (
                <span key={emp.value} style={{
                  display: 'flex', alignItems: 'center', gap: '5px',
                  background: '#9D7BFF20', border: '1px solid #9D7BFF40',
                  borderRadius: '20px', padding: '3px 10px',
                  fontSize: '11px', color: '#c4b5fd'
                }}>
                  <img src={Avatar} style={{ width: 16, height: 16, borderRadius: '50%' }} />
                  {emp.label}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Reaction footer */}
        {(reactionAllowId === "1" || reactionDislikeId === "1" || commentId === "1" || repliesId === "1") && (
          <div style={{
            padding: '10px 14px',
            borderTop: '1px solid rgba(255,255,255,0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', gap: '14px' }}>
              {reactionAllowId === "1" && (
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#4ADE80' }}>
                  <FaThumbsUp /> 0
                </span>
              )}
              {reactionDislikeId === "1" && (
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#F87171' }}>
                  <AiFillDislike /> 0
                </span>
              )}
              {commentId === "1" && (
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#60A5FA' }}>
                  <BsChatFill /> 0
                </span>
              )}
              {repliesId === "1" && (
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#C084FC' }}>
                  <FaShare /> 0
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* ── Controls ── */}
      <div style={{
        marginTop: '14px', padding: '12px 14px',
        background: 'var(--noti-widget-bg)',
        border: '1px solid var(--noti-widget-border)',
        borderRadius: '12px', display: 'flex', flexDirection: 'column', gap: '12px'
      }}>
        {/* Preview Theme */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: '12px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
            Preview Theme
          </span>
          <select style={{
            background: 'var(--select-option-bg-color)',
            border: '1px solid var(--table-border-color)',
            borderRadius: '8px', padding: '4px 10px',
            fontSize: '12px', color: 'var(--primary-text-color)',
            cursor: 'pointer', outline: 'none'
          }}>
            <option>Festival (Orange)</option>
          </select>
        </div>

        {/* Device View */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: '12px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
            Device View
          </span>
          <div style={{ display: 'flex', gap: '6px' }}>
            {[
              { id: 'desktop', Icon: FiMonitor },
              { id: 'mobile', Icon: HiDeviceMobile }
            ].map(({ id, Icon }) => (
              <button
                key={id}
                onClick={() => setDeviceView(id)}
                style={{
                  width: 34, height: 34, borderRadius: '8px', cursor: 'pointer',
                  background: deviceView === id ? '#8660F820' : 'var(--device-icon-bg)',
                  border: deviceView === id ? '1px solid #8660F860' : '1px solid transparent',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
              >
                <Icon style={{
                  fontSize: 17,
                  color: deviceView === id ? '#c4b5fd' : 'var(--primary-text-color)'
                }} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LivePreview
